interface ButtonType {
  className?: string;
  caption?: string;
  url?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  onClick?: () => void;
  disabled: boolean;
}

export const Button = (props: ButtonType) => {
  return (
    <button
      className='text-white bg-[#ffc42c] min-w-[180px] text-base h-12 rounded font-medium cursor-pointer hover:bg-[rgba(255,196,44,0.8)]'
      type={props.type ?? 'button'}
      disabled={props.disabled}
    >
      {props.caption}
    </button>
  );
};
